import { css } from '@emotion/react';
import { useTooltip } from '@frontend/design-system';
import { StatusBadge } from '../../../../../components/status-badge';

type VisibilityChipProps = {
  enabled: boolean;
  variant: 'online-scheduling' | 'ai-receptionist';
  tooltip: string;
  onClick: () => void;
};

export const VisibilityChip = ({ enabled, variant, tooltip, onClick }: VisibilityChipProps) => {
  const { Tooltip, tooltipProps, triggerProps } = useTooltip();

  return (
    <>
      <button
        type='button'
        {...triggerProps}
        onClick={onClick}
        aria-label={tooltip}
        aria-pressed={enabled}
        css={visibilityButtonStyles}
      >
        <StatusBadge variant={variant} disabled={!enabled} />
      </button>
      <Tooltip {...tooltipProps}>{tooltip}</Tooltip>
    </>
  );
};

const visibilityButtonStyles = css({
  appearance: 'none',
  border: 0,
  background: 'transparent',
  padding: 0,
  cursor: 'pointer',
  '> div': {
    transition: 'background 150ms ease, filter 150ms ease',
  },
  "& > div[data-disabled='false']": {
    border: '1px solid currentColor',
  },
  '&:hover > div': {
    filter: 'brightness(0.9) saturate(1.25)',
  },
  "&:hover > div[data-disabled='true']": {
    background: 'var(--fabric-color-surface-inset-hover)',
    filter: 'none',
  },
});
